import { parseStack } from './stack.js';
const MAX_CAUSES = 5;
const MAX_VALUE_LENGTH = 2000;
function clip(text) {
    return text.length > MAX_VALUE_LENGTH ? `${text.slice(0, MAX_VALUE_LENGTH)}…` : text;
}
/** The error and its `cause` chain, innermost first (the order the event format wants). */
function chainOf(err) {
    const chain = [];
    let current = err;
    while (current instanceof Error && chain.length < MAX_CAUSES && !chain.includes(current)) {
        chain.push(current);
        current = current.cause;
    }
    return chain.reverse();
}
function exceptionValue(err, handled) {
    const frames = parseStack(err.stack);
    return {
        type: err.name || 'Error',
        value: clip(err.message),
        ...(frames.length > 0 ? { stacktrace: { frames } } : {}),
        mechanism: { type: 'generic', handled },
    };
}
/** Turns anything thrown into an event: errors with their causes and frames, other values as a message. */
export function buildEvent(thrown, ctx) {
    const handled = ctx.handled ?? true;
    const event = {
        event_id: ctx.eventId,
        timestamp: Math.floor(ctx.timestamp.getTime() / 1000),
        platform: ctx.platform,
        level: ctx.level ?? 'error',
        logger: ctx.app,
        ...(ctx.release !== undefined ? { release: ctx.release } : {}),
        ...(ctx.environment !== undefined ? { environment: ctx.environment } : {}),
        ...(ctx.serverName !== undefined ? { server_name: ctx.serverName } : {}),
        tags: { app: ctx.app, ...(ctx.tags ?? {}) },
        ...(ctx.extra !== undefined ? { extra: ctx.extra } : {}),
    };
    if (thrown instanceof Error) {
        event.exception = { values: chainOf(thrown).map((e) => exceptionValue(e, handled)) };
    }
    else {
        let formatted;
        try {
            formatted = typeof thrown === 'string' ? thrown : JSON.stringify(thrown);
        }
        catch {
            formatted = String(thrown);
        }
        event.message = { formatted: clip(formatted ?? String(thrown)) };
    }
    return event;
}
//# sourceMappingURL=event.js.map